import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TeamUser } from './teamUser'
import { TeamVehicle } from './teamVehicles'
import { editChildNode, getUsersFromNode, organisationNodeSelected, removeChildNode } from '../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'
import { fetchVehiclesSorted } from '../../../state/actions/vehicles'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import View from '@modul-connect/shared/components/atoms/view'
import TextField from '@modul-connect/shared/components/molecules/textField'
import { CustomModal2, styles } from '@modul-connect/shared/components/molecules/modal/customModal2'
import { P } from '@modul-connect/shared/components/atoms/text'
import theme from '@modul-connect/shared/theme'
import { useNavigate } from 'react-router-dom'

export const TeamDetails = ({ uuid, skipFetch }) => {
  const subtrees = useSelector(state => state.subtrees.subtrees || []) 
  const allTeams = subtrees.flatMap(org => org.children || [])
  const team = allTeams.find(t => t.uuid === uuid)
  const organisationNode = useSelector(state => state.organisation_node)
  

  const [isEditing, setIsEditing] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [teamExists, setTeamExists] = useState(false)
  
  const users = organisationNode.uuid ? organisationNode.users.map(user => ({
    ...user,
    name: `${user.firstName} ${user.lastName}`,
  })) : []

  const [name, setName] = useState(team?.name ?? '')

  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth0()

  const S = styles()

  const navigate = useNavigate()

  const parentOrg = subtrees.find(org =>
    org.children?.some(child => child.uuid === uuid))

  useEffect(() => {
    dispatch(organisationNodeSelected( 
      uuid
    )) 
  }, [uuid])

  useEffect(() => {
    if (skipFetch) return
    getAccessTokenSilently()
      .then(token => {
        dispatch(getUsersFromNode( 
          token,
          uuid
        )) 
      })
   
  }, [uuid])



  useEffect(() => {
    if (skipFetch) return
    getAccessTokenSilently()
      .then(accessToken => {
        var option = {
          rowsPerPage: 1000,
          currentpage: 0,
          sort: 'name',
          searchStr: '',
          node: uuid
        }
        dispatch(fetchVehiclesSorted( 
          accessToken,
          option
        )) 
      })
   
  }, [uuid])


  const removeTeam = () => {
    setIsDeleting(false)
    getAccessTokenSilently().then(token => {
      dispatch(removeChildNode(token, uuid))

      const nodes = parentOrg.children.filter(node => node.uuid !== uuid)
      
      const fallbackUuid = nodes[0]?.uuid

      if (fallbackUuid) {
        navigate(`/fleet/fleet_teams/${fallbackUuid}`)
      } else {
        navigate('/fleet/fleet_teams') 
      }
    })
  }
  

  useEffect(() => {
    setName(team?.name ?? '')
  }, [team?.name])

  const saveTeamName = () => {
    const newName = name.trim()
 
    const sameAsCurrent = newName.toLowerCase() === team?.name.trim().toLowerCase()
    if (sameAsCurrent) { 
      setIsEditing(false) 
      return
    }

    const nameTaken = parentOrg?.children?.some(c => c.uuid !== uuid &&
      c.name.trim().toLowerCase() === newName.toLowerCase()
    )

    if (nameTaken) {
      setTeamExists(true)
      return
    }

    getAccessTokenSilently().then(token => {
      dispatch(editChildNode(token, uuid, newName))
      setIsEditing(false)
    })
  }
  
  return (
    <React.Fragment>
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingTop: 20 }}>
        {isEditing && (
          <CustomModal2
            openModal={isEditing}
            title="Change name"  
            primaryButton='Save'
            disabled={!name.trim()}
            secondaryButton='Cancel'
            onSave={saveTeamName}
            onCancel={() => {
              setIsEditing(false)
              setTeamExists(false)
            }} 
            teamAlreadyExist={teamExists}
          >
            <TextField icon="Pencil2" extend={S.modal_input} value={name} onChange={(e) => setName(e.target.value)} />
          </CustomModal2>
        )}
        {isDeleting && (
          <CustomModal2
            openModal={isDeleting}
            title="Are you sure?"  
            primaryButton='Yes'
            secondaryButton='Cancel'
            onSave={removeTeam}
            disabled={users.length}
            onCancel={() => setIsDeleting(false)}
            isPrimaryColor={false}
          >
            {users.length ? (
              <View extend={{ '& strong': { fontWeight: 600 } }}>
                <P noPadding>
                      You're about to <strong>Delete</strong> <strong>{team?.name}</strong>.
                </P>
                <P noPadding>
                      Please remove all users before deleting the team.
                </P>
              </View>

            ) : (
              <View extend={{ '& strong': { fontWeight: 600 } }}>
                <P noPadding>
                  You're about to <strong>Delete</strong> <strong>{team?.name}</strong>.
                </P>
                <P noPadding>
                  Please note that all saved data for <strong>{team?.name}</strong> will be removed.
                </P>
              </View>
            )}
        
          </CustomModal2>
        )}
        <Button icon='Pencil' color={'transparent'} extend={{ color: theme.colors.midDarkGrey, fontSize: '16px' }} onClick={() => setIsEditing(true)}>{team?.name}</Button>
        <Button icon='Delete' color={'transparent'} extend={{ color: theme.colors.midDarkGrey, fontSize: '16px' }} onClick={() => setIsDeleting(true)}>Delete team</Button>
      </View>
  
      <TeamUser uuid={uuid} parent={parentOrg} />
      <TeamVehicle uuid={uuid} parent={parentOrg} />
    </React.Fragment>
  )
}
